import { useEffect } from 'react';

import { useLenisContext } from '@providers/LenisProvider';

export const useLenisAutoResize = () => {
  const lenisRef = useLenisContext();

  useEffect(() => {
    if (!lenisRef?.current) return;

    const observer = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        lenisRef.current?.dimensions.resize();
      });
    });

    observer.observe(document.body);

    return () => observer.disconnect();
  }, [lenisRef]);
};
